// Vector tile sources of the map v2 page. Kept here rather than in providers/map.ts, which the current
// /map iterates over to declare its own sources.

export const ROADS_SOURCE_ID = 'roads';
export const ROAD_SECTIONS_SOURCE_ID = 'road-sections';

// The tiles of whole roads exist at every zoom; the section tiles (api RoadSectionsLayer) start at
// ROAD_SECTIONS_MIN_ZOOM, so the roads are drawn below it and the sections from it.
export const ROAD_SECTIONS_MIN_ZOOM = 9;
export const TILES_MAX_ZOOM = 15;

export const tilesUrl = (backendUrl: string, source: string): string => `${backendUrl}/map/${source}/{z}/{x}/{y}.mvt`;

export interface RoadSectionTileProperties {
    id: string;
    roadId: string;
}

// Id of the Mapbox layer drawing the sections, the one the pointer interacts with.
export const ROAD_SECTIONS_LAYER_ID = 'map-v2-road-sections';
